import { authorizedFetch, baseUrl, removeEmpty } from './base';
import queryString from 'query-string';

async function listing(params = {}) {
  const path = `${baseUrl}/console/api/super_admin/order_payments?${queryString.stringify(
    removeEmpty(params)
  )}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function listing_partner(params = {}) {
  const path = `${baseUrl}/console/api/super_admin/order_payments_partner?${queryString.stringify(
    removeEmpty(params)
  )}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function CreateAndCompletedOrderPayment(params) {
  const path = `${baseUrl}/console/api/super_admin/create_completed_order_payment`;

  return await authorizedFetch(path, {
    method: 'POST',
    body: JSON.stringify(params)
  });
}

async function refundOrder(id, params) {
  const path = `${baseUrl}/console/api/super_admin/refund_order_payment/${id}`;

  return await authorizedFetch(path, {
    method: 'PUT',
    body: JSON.stringify(params)
  });
}

async function updateOrder(id, params) {
  const path = `${baseUrl}/console/api/super_admin/order_payment/${id}`;

  return await authorizedFetch(path, {
    method: 'PUT',
    body: JSON.stringify(params)
  });
}

async function completeOrder(id, params) {
  const path = `${baseUrl}/console/api/super_admin/completed_order_payments/${id}`;

  return await authorizedFetch(path, {
    method: 'PUT',
    body: JSON.stringify(params)
  });
}

const orderPaymentApis = { listing, listing_partner, CreateAndCompletedOrderPayment, refundOrder, updateOrder, completeOrder };

export default orderPaymentApis;
